import React from 'react';
import Certification from './Certification';
import Certificationdata from './Certificationdata';
function fcert(value){
    return(
      <Certification
      
      title={value.title}
      org={value.org}
      date={value.date}
      link={value.link}
  
      />
    )
  }
export default function Maincert() {
  return (
    <div>
        <div className='certification'>
      {Certificationdata.map(fcert)}

  </div>
    </div>
  )
}